import { toast } from 'react-toastify';
import api from '../../services/api';
import {
	GET_GROUP_SETTINGS_FAIL,
	GET_GROUP_SETTINGS_REQ,
	GET_GROUP_SETTINGS_SUCCESS,
	SAVE_GROUP_SETTINGS_FAIL,
	SAVE_GROUP_SETTINGS_REQ,
	SAVE_GROUP_SETTINGS_SUCCESS,
} from '../constants/groupSettings';

export const getGroupSettings = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: GET_GROUP_SETTINGS_REQ });
		const {
			userLogin: { userInfo },
		} = getState();

		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${userInfo.gmBackendToken}`,
			},
		};

		const { data } = await api.get(`/api/group-settings/${id}`, config);

		dispatch({
			type: GET_GROUP_SETTINGS_SUCCESS,
			payload: data?.body,
		});
	} catch (error) {
		dispatch({
			type: GET_GROUP_SETTINGS_FAIL,
			payload:
				error.response && error.response.data.error
					? error.response.data.error
					: error.message,
		});

		const message =
			error.response && error.response.data.error
				? error.response.data.error
				: error.message;

		if (message === 'NotAuthorized') {
			toast.error('Please login from extension and the reload this page');
			localStorage.removeItem('_gm_usr');
			window.location.reload();
		} else if(error.response.status === 401){
			toast.error("Autorization failed, please re-login to the extension")
		} else {
			toast.error(message);
		}
	}
};

export const updateGroupSettings =
	(id, setting) => async (dispatch, getState) => {
		try {
			dispatch({
				type: SAVE_GROUP_SETTINGS_REQ,
			});

			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${userInfo.gmBackendToken}`,
				},
			};

			const { data } = await api.post(
				`/api/group-settings/${id}`,
				setting,
				config
			);

			dispatch({
				type: SAVE_GROUP_SETTINGS_SUCCESS,
				payload: data?.body,
			});

			toast.success(data?.message || 'Group Settings Updated Successfully');
		} catch (error) {
			const message =
				error.response && error.response.data.error
					? error.response.data.error
					: error.message;

			dispatch({
				type: SAVE_GROUP_SETTINGS_FAIL,
				payload: message,
			});
			if (message === 'NotAuthorized') {
				toast.error('Please login from extension and the reload this page');
				localStorage.removeItem('_gm_usr');
				window.location.reload();
			} else if(error.response.status === 401){
				toast.error("Autorization failed, please re-login to the extension")
			} else {
				toast.error(message);
			}
		}
	};
